/**
 * Where the focus goes when a modal window closes: back to the control that opened it, or, when that
 * control is gone from the page — a row deleted meanwhile, a menu that closed with its items — to
 * the fallback the page always draws.
 */
export function focusReturnTarget<T extends { isConnected: boolean }>(
  opener: T | null,
  fallback: T | null,
): T | null {
  return opener?.isConnected ? opener : fallback;
}
